import { http } from 'http';

export default {
  setKms: (plate, km) => http.put(`/flex/vhstoragemgmt/adjustKm`, { plate, km }),

  setTaskState: (idTask, idTaskStatus) =>
    http.put(`/flex/vhstoragemgmt/updateTaskStatus`, { idTask, idTaskStatus }),

  saveDetailPap: data => http.put(`/flex/vhstoragemgmt/papDetail`, data)
};
